import "./ProjectList.scss";
import { IoLocationSharp } from "react-icons/io5";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { baseUrl } from "../../../utils/apiData";

const ProjectList = ({ category, dataList }) => {
  const navigate = useNavigate();
  const { type } = useParams();

  const [searchParams] = useSearchParams();
  const search = searchParams.get("category");
  

  const [filter, setFilter] = useState(
    search ? category?.find((ele) => ele?.name === search)?._id : ""
  );

  useEffect(() => {
    setFilter(search ? category?.find((ele) => ele?.name === search)?._id : "")
  }, [search])
 
  return (
    <section className="project_list">
      <div className="content_wrap p_t p_b">
        {type === "Builder" && (
          <div className="filter_line">
            {/* <button
              className={`square_btn ${filter === ele?._id ? "active" : ""}`}
              onClick={() => setFilter("")}
            >
              Ongoing
            </button> */}
            {category?.map((ele, l) => (
              <button
                type="button"
                key={l}
                className={`square_btn ${filter === ele?._id ? "active" : ""}`}
                onClick={() => setFilter(ele?._id)}
              >
                {ele?.name}
              </button>
            ))}
          </div>
        )}
        {(filter ? dataList?.filter((ele) => ele?.category?._id?.includes(filter))
          ?.length : dataList?.length) > 0 ? (
          <div className="project_grid">
            {(filter ? dataList
              ?.filter((ele) => ele?.category?._id?.includes(filter)) : dataList)
              ?.map((data) => {
                return (
                  <div className="project_card" key={data?._id}>
                    <div className="img_wrap">
                      <img src={`${baseUrl}/${data?.image}`} alt="Project" />
                    </div>
                    <p className="gold">{data?.name}</p>
                    <div className="info">
                      <p className="gold">
                        <IoLocationSharp /> {data?.location_name}
                      </p>
                    </div>
                    <div className="info">
                      {data?.type?.map((ele, k) => {
                        return (
                          <p>
                            {k > 0 && <span></span>} {ele}
                          </p>
                        );
                      })}
                    </div>
                    {type === "Contractor" && (
                      <p className="gold">{data?.small_description}</p>
                    )}
                    {type !== "Contractor" && (
                      <div className="btn_line">
                        <button
                          type="button"
                          className="border_btn"
                          onClick={() => navigate(`/project/${data?.slug}`)}
                        >
                          Know More
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        ) : (
          <p className="gold text-center">Data not found...</p>
        )}
      </div>
    </section>
  );
};

export default ProjectList;
